import React from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
interface StatusBadgeProps {
  status: string;
}
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status
}) => {
  let color = '';
  let bgColor = '';
  let icon = null;
  let text = '';
  switch (status) {
    case 'operational':
      color = 'text-green-400';
      bgColor = 'bg-green-500/20';
      icon = <CheckCircle2 size={16} data-id="element-1045" />;
      text = 'Betriebsbereit';
      break;
    case 'maintenance':
      color = 'text-yellow-400';
      bgColor = 'bg-yellow-500/20';
      icon = <AlertTriangle size={16} data-id="element-1046" />;
      text = 'Wartung';
      break;
    case 'error':
      color = 'text-red-400';
      bgColor = 'bg-red-500/20';
      icon = <XCircle size={16} data-id="element-1047" />;
      text = 'Fehler';
      break;
    default:
      color = 'text-gray-400';
      bgColor = 'bg-gray-500/20';
      icon = <CheckCircle2 size={16} data-id="element-1048" />;
      text = 'Unbekannt';
  }
  return <div className={`flex items-center gap-2 px-3 py-1 rounded-full ${bgColor} ${color}`} data-id="element-1049">
      {icon}
      <span className="text-sm font-medium" data-id="element-1050">{text}</span>
    </div>;
};